import { uniq } from 'lodash-es';

import { Injectable } from '@angular/core';

import { NavBarItem } from '@core/config';
import { MwIconLoaderService } from '@core/services';

@Injectable()
export class MwNavListService {
  constructor(private iconLoaderService: MwIconLoaderService) {}
  loadIcons(items: NavBarItem[]): boolean {
    const svgIcons = items.map((t) => t.svgIcon).filter((svgIcon) => !!svgIcon);
    const icons = items.map((item) => item.icon).filter((icon) => !!icon);
    const uniqueSvgIcons: string[] = uniq(svgIcons);
    this.iconLoaderService.load(uniqueSvgIcons);

    return svgIcons.length > 0 || icons.length > 0;
  }

  filterItemsWithChildren(items: NavBarItem[]): NavBarItem[] {
    return items.filter((t) => t.children != null);
  }
}
